"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const reducer_1 = require("../../reducer");
const DocUpload_1 = __importDefault(require("./DocUpload"));
function DocumentManagement({ currentLocation }) {
    const unsignedLocationData = (0, react_1.useMemo)(() => {
        return [currentLocation].filter((location) => {
            return location && location.isCurrentLocationManagerSigner;
        });
    }, [currentLocation]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "verify-store-information", children: unsignedLocationData &&
            unsignedLocationData.map((data, index) => ((0, jsx_runtime_1.jsx)(DocUpload_1.default, { pageTitle: 'Document Verification Required', displayContinue: false, locationData: [data], makeSyncCallback: true }, `doc-upload-${index}-${data.adsStoreNumber}`))) }));
}
function mapStateToProps(state) {
    return {
        allLocations: reducer_1.selectors.allLocations(state),
        currentLocation: reducer_1.selectors.currentLocation(state),
        currentLocationIndex: reducer_1.selectors.currentLocationIndex(state),
    };
}
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps))(DocumentManagement);
